import { render, staticRenderFns } from "./unBindWx.vue?vue&type=template&id=cd869aae&scoped=true"
import script from "./unBindWx.vue?vue&type=script&lang=ts"
export * from "./unBindWx.vue?vue&type=script&lang=ts"
import style0 from "./unBindWx.vue?vue&type=style&index=0&id=cd869aae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd869aae",
  null
  
)

export default component.exports